const BaseComponent = require('common/newsCarousel');

class switchImgFederation extends BaseComponent {
  componentInit () {
    super.componentInit();
    let remark = $('.ZCY-federation-carousel .remark');
    remark.map((index, item) => {
      let text = $(item).text();
      text = text.length > 56 ? `${text.slice(0, 53)}...` : text;
      $(item).text(text);
    });
    // if (this.$item.length <= 0) {
    //   return;
    // }
    // let that = this;
    // let clone = that.$item.first().clone(); // 克隆第一张图片
    // that.$itemBox.append(clone); // 复制到列表最后
    // that.size = that.$item.length + 1;
    // for (let j = 0; j < that.size - 1; j++) {
    //   that.$btnBox.append('<li></li>');
    // }
    // that.$btn = that.$btnBox.find('li');
    // that.$btn.first().addClass('on');
    // that.t = setInterval(() => {
    //   that.count++;
    //   that.move();
    // }, 5000);
    // that.bindEvent();

    // $.map(that.$el.find('.img li'), (el) => {
    //   const $title = $(el).find('.title');
    //   const $remark = $(el).find('.remark');
    //   const lineHeight = parseInt(that.getCSS($title[0], 'line-height'), 10);
    //   if ($title[0].offsetHeight > lineHeight) {
    //     that.overflowhidden($title[0], 2, $title[0].innerHTML);
    //     that.overflowhidden($remark[0], 2, $remark[0].innerHTML);
    //     $title.css('visibility', 'visible');
    //     $remark.css('visibility', 'visible');
    //   } else {
    //     that.overflowhidden($title[0], 1, $title[0].innerHTML);
    //     that.overflowhidden($remark[0], 2, $remark[0].innerHTML);
    //     $title.css('visibility', 'visible');
    //     $remark.css('visibility', 'visible');
    //   }
    // });
  }
}


module.exports = switchImgFederation;
